import { KYMW5002Model } from '../kymw5002.model';
import { GetSearchImageListModel } from '../vo/get-search-image-list.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 検索画像リストを取得する。
 *
 * @export
 * @class GetSearchImageListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class KYMW50getSearchImageListService extends PlessJsonResponderSub<any> {

  private model: KYMW5002Model = null;
  private vo: GetSearchImageListModel = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetSearchImageListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        PcodeList: this.vo.pcodeList,
        GuideGoodsName: this.vo.guideGoodsName,
        GuideStandardName: this.vo.guideStandardName,
        ImageName: this.vo.imageName,
        ImageFileName: this.vo.imageFileName,
        ImageBelongId: this.vo.imageBelongId,
        ImageKind: this.vo.imageKind,
        ImageType: this.vo.imageType,
        ProcessInstruct: this.vo.processInstruct,
        RemarksList: this.vo.remarksList,
        CookingExPublish: this.vo.cookingExPublish,
        CookingDiv: this.vo.cookingDiv,
        CookingNameList: this.vo.cookingNameList,
        MaterialNameList: this.vo.materialNameList,
        KeyWordList: this.vo.keyWordList,
        EventId: this.vo.eventId,
        PhotoContentsDiv: this.vo.photoContentsDiv,
        PhotoStudioId: this.vo.photoStudioId,
        ImageInstructUserId: this.vo.imageInstructUserId,
        ImageInstructDateFrom: this.vo.imageInstructDateFrom,
        ImageInstructDateTo: this.vo.imageInstructDateTo,
        FileRegistDateFrom: this.vo.fileRegistDateFrom,
        FileRegistDateTo: this.vo.fileRegistDateTo,
        Status: this.vo.status,
        ImageInstructDiv: this.vo.imageInstructDiv,
        ImageEnabledDiv: this.vo.imageEnabledDiv,
        ThisOrderCode: this.vo.thisOrderCode,
        PhotoScheduleFrom: this.vo.photoScheduleFrom,
        PhotoScheduleTo: this.vo.photoScheduleTo,
        ClassCode: this.vo.classCode,
        MultipleCode: this.vo.multipleCode,
        StartOrderCode: this.vo.startOrderCode,
        StartDelivCatalogId: this.vo.startDelivCatalogId,
        BillingName: this.vo.billingName,
        BuyerCode: this.vo.buyerCode,
        OutputFlg: this.vo.outputFlg,
        CarriedForward: this.vo.carriedForward,
        C2pfTarget: this.vo.c2pfTarget,
        PhotographingChangeSchedule: this.vo.photographingChangeSchedule,
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param {KYMW5002Model} model
   * @param {GetSearchImageListModel} vo
   * @memberof GetSearchImageListService
   */
  execute(model: KYMW5002Model, vo: GetSearchImageListModel) {
    this.model = model;
    this.vo = vo;
    this.send('KYMW50getSearchImageList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetSearchImageListService
   */
  success(data: any) {
    this.model.updateSearchImageList(data);
  }
}
